<template>
  <div class="overlay">
    <div class="message-box">
      {{ msg }}
    </div>
  </div>
</template>
<script>
import { transaction } from '@/service/restService'

export default {
  name: 'ProcessTemplate',
  data () {
    return {
      msg: '...'
    }
  },
  created () {
    const token = this.$route.query.token
    const orderId = this.$route.query.orderId
    const at = this.$route.query.at // assuming 'at' is amount or access token

    if (token && orderId && at) {
      localStorage.setItem('token', token)

      // Clean URL
      const newQuery = { ...this.$route.query }
      delete newQuery.token
      delete newQuery.orderId
      delete newQuery.at
      this.$router.replace({ query: newQuery }).catch(() => {})

      // Load Razorpay script first
      this.loadRazorpayScript().then(() => {
        this.createOrder(at, orderId)
      }).catch(() => {
        this.msg = 'Failed to load  gateway. Please try again.'
      })
    } else {
      this.msg = 'Invalid  link. Please try again.'
    }
  },
  methods: {
    loadRazorpayScript () {
      return new Promise((resolve, reject) => {
        if (window.Razorpay) {
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = 'https://checkout.razorpay.com/v1/checkout.js'
        script.onload = resolve
        script.onerror = reject
        document.body.appendChild(script)
      })
    },

    createOrder (amount, orderId) {
      const options = {
        key: 'rzp_live_MRrPwvjdEfjSMf',
        amount: amount * 100,
        currency: 'INR',
        name: 'MegaBull',
        description: 'Clear History',
        image: 'https://trade.megabull.in/static/favicon/favicon-76x76.png',
        order_id: orderId,
        prefill: {
          name: this.$store.state.user.firstName || '',
          email: this.$store.state.user.emailId || '',
          contact: ''
        },
        theme: { color: '#3399cc' },
        handler: (response) => {
          const data = {
            orderId: response.razorpay_order_id,
            paymentId: response.razorpay_payment_id
          }
          transaction(data)
            .then(() => {
              this.msg = ' Successful!'
            })
            .catch((error) => {
              this.msg = error.response.data.message[0] || ' failed'
            })
        },
        modal: {
          ondismiss: () => {
            this.msg = 'cancelled'
          }
        }
      }

      try {
        const rzp = new window.Razorpay(options)
        rzp.open()
      } catch (err) {
        console.error('Razorpay error:', err)
        this.msg = ' gateway error. Please try again.'
      }
    }
  }
}
</script>
<style scoped>
.overlay {
  /* Full screen fixed overlay */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh; /* Crucial for mobile: uses dynamic viewport height */

  /* Perfect centering */
  display: flex;
  justify-content: center;
  align-items: center;

  /* Semi-transparent dark background */
  background-color: rgba(0, 0, 0, 0.5);

  /* On top of everything */
  z-index: 9999;

  /* Prevent scroll behind */
  overscroll-behavior: contain;
}

.message-box {
  /* Responsive text size */
  font-size: clamp(1.8rem, 6vw, 3rem); /* Scales beautifully on all screens */
  font-weight: bold;
  color: white;
  text-align: center;

  /* Card-like appearance */
  background-color: rgba(0, 0, 0, 0.8);
  padding: 2rem 3rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);

  /* Max width for large screens, full width on small phones */
  max-width: 90%;
  width: fit-content;

  /* Smooth text rendering on mobile */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* Prevent accidental selection */
  user-select: none;
}

/* Extra tweak for very small screens */
@media (max-height: 500px) {
  .message-box {
    padding: 1.5rem;
    font-size: 1.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/ProcessTemplate.vue